<template>
  <div class="customer h-full">
    <div class="shopInfo">
      <p><span>品牌：{{brandInfo.brandName}}</span><span>电话：<span v-if="storeArea" style="margin-right: 10px;border-right: 1px solid #ccc;padding-right: 10px;">+{{storeArea}}</span>{{brandInfo.customerHotline}}</span></p>
    </div>
    <div v-if="isAmend" class="customer-order-amend-title">
      修改订单中
    </div>
    <template v-if="visible">
      <cc-user @openOrderPage="openOrderPage"></cc-user>
      <cc-order-info @openOrderPage="openOrderPage"></cc-order-info>
      <cc-store-list @openOrderPage="openOrderPage"></cc-store-list>
    </template>
  </div>
</template>

<script>
  import User from '@/components/Pages/customer/User.vue';
  import OrderInfo from '@/components/Pages/customer/OrderInfo.vue';
  import StoreList from '@/components/Pages/customer/StoreList.vue';
  import {mapState} from 'vuex';
  import {getUrlParameter, each, deepClone, formatPrice} from '@/utils/assist'
  import {
    createAdditional,
    createCombo,
    calculateAllAdditional,
    isDisabled,
    getComboProducts,
    getAdditionalUseMaterial,
    calculateAllCombo,
    getComboUseProductsAndMaterial,
    getRefIdMap
  } from '@/utils/productAction';
  function initialize() { 
   console.log('地图加载完成')
  } 
  window.initialize = initialize

  export default {
    name: 'customerCache',
    data() {
      let urlObj = getUrlParameter();
      return {
        storePhone: null,
        visible: false,
        storeArea: urlObj.storeArea
      };
    },
    activated() {
      console.error('旧的custome.vue执行了 activated...');
      this.executeAmendOrder()
    },
    created() {
      console.error('旧的custome.vue执行了 create...');
      let isUpdateAmend = this.executeAmendOrder();
      if(isUpdateAmend) return;
      let urlObj = getUrlParameter();
      if (typeof urlObj === 'object' && urlObj.hasOwnProperty('platformKey') && urlObj.hasOwnProperty('orderId')) { // OCRM链接跳转入口 修改订单初始化
        this.server.setPublicData({platformKey: urlObj.platformKey});
        this.orderAmendInit(urlObj.orderId);
      } else {
        this.visible = true;
        this.$emit('updateRouterStatus', true)
      }
    },
    mounted() {
    },
    computed: {
      ...mapState({
        isAmend: state => state.booking.user.orderAmend.isAmend, // 修改订单状态
        orderAmend: state => state.booking.user.orderAmend, // 修改订单数据
        phone: state => state.booking.user.phone, // 用户手机号码
        name: state => state.booking.user.name, // 用户名字
        sendType: state => state.booking.user.sendType, // 业务类型
        address: state => state.booking.user.address, // 用户地址
        oprInfo: state => state.booking.user.oprInfo, // 营运商配置信息
        brandInfo: state => state.booking.user.brandInfo, // 品牌数据
        store: state => state.booking.store.data, // 门店信息
        menu: state => state.booking.menu.data, // 餐单信息
      }),
    },
    methods: {
      executeAmendOrder() {
        let orderAmend = this.orderAmend;
        if (orderAmend.update) { // 本地入口修改订单 初始化
          this.orderAmendInit(this.orderAmend.orderId);
          this.$store.commit('booking/user/update', {
            orderAmend: {
              ...orderAmend,
              update: false
            }
          })
          return true
        }
        return false
      },
      modalError(content) { // 出错提示框
        this.$Modal.error({title: '提示', content})
      },
      async orderAmendInit(orderId, isRouter) {  // 订单修改初始化 1、清除vuex购物车数据 默认忽略选择营运商和品牌 路由禁止跳转
        this.$store.commit('booking/user/update', {isChoose: true});
        this.$store.dispatch('booking/cart/clear');
        this.$emit('updateRouterStatus', false);
        // 请求运营商 品牌 门店 菜单
        let orderAmend = this.orderAmend,
          oprInfo = this.oprInfo,
          brandInfo = this.brandInfo,
          menuId,
          storeId,
          brandId,
          sendType,
          store = {},
          menu = {},
          _this = this,
          requestList = [],
          urlNameList = ['getPlatformByKey', 'getBrandById', 'getStoreInfoForCC', 'getProductMenu'],
          dataList = [
            oprInfo,
            brandInfo,
            store,
            menu
          ],
          argList,
          orderData;
          await this.server
          .get({
            name: "getTencentMapKey",
            data: {} })
          .then(result => {
            let tencentMapKey = '';
            if(result&&result.status==1&&result.data){
              if(result.data.type==1){
                var _casp = document.createElement("script");
                _casp.src =  "//map.qq.com/api/js?v=2.exp&key="+ result.data.key+'&libraries=place,service&callback=initialize'
                _casp.type = "text/javascript";
                var s = document.getElementsByTagName("script")[0];
                s.parentNode.insertBefore(_casp, s);
                tencentMapKey = result.data.key
              } else {
                if(result.data.key=='aa3b85fcb070c2afd2df4e76e4f4f813'){
                  window._AMapSecurityConfig = {
                      securityJsCode: result.data.secretKey,
                  }
                }
                var _casp = document.createElement("script");
                _casp.src =  "//webapi.amap.com/maps?v=1.4.12&key="+ result.data.key+'&plugin=AMap.Autocomplete&plugin=AMap.DistrictSearch'
                _casp.type = "text/javascript";
                var s = document.getElementsByTagName("script")[0];
                s.parentNode.insertBefore(_casp, s);
              }
              this.$store.dispatch('booking/user/update', {tencentMapKey});
            }

          })
        if (Object.keys(orderAmend.orderData).length) {
          orderData = orderAmend.orderData
        } else {
          orderData = await this.getOrderDetails(orderId)
        }
        menuId = orderData.menuId;
        storeId = orderData.storeId;
        sendType = orderData.orderType;
        brandId = orderData.brandId;
        argList = [
          {},
          {
            brandId
          },
          {
            storeId,
            businessType: sendType,
            coordinate: [orderData.longitude, orderData.latitude],
            checkChannel: false
          },
          {
            storeId,
            sendType,
          }
        ];
        let urlObj = getUrlParameter();
        // 改单时，根据餐单id获取餐单
        if(typeof urlObj === 'object' && urlObj.hasOwnProperty('platformKey') && urlObj.hasOwnProperty('orderId')){
          argList[3].fromType=orderData.fromType;
          argList[3].isCCChangeOrder = true
        }
        argList.forEach((arg, index) => {
          let urlName = urlNameList[index],
            isRequest = !Object.keys(dataList[index]).length;
          if (urlNameList) {
            requestList.push(new Promise((resolve, reject) => {
              if (isRequest) {
                _this.server.get({name: urlName, data: arg}).then((res) => {
                  if (res.status === 1) {
                    return resolve(res.data)
                  }
                  return reject()
                }).catch(() => {
                  reject();
                })
              } else {
                resolve(0)
              }
            }))
          }
        });
        //  等待所有请求返回
        Promise.all(requestList).then(async function ([oprInfo, brandInfo, store, menu]) {
          let userData = {};
          if (oprInfo !== 0) userData.oprInfo = oprInfo;
          if (brandInfo !== 0) userData.brandInfo = brandInfo;
          userData.vipPhone = orderData.vipPhone;
          userData.countryAreaCode = orderData.consigneePhoneCountryCode;
          userData.phone = orderData.consigneePhone;
          userData.name = orderData.consigneeName;
          userData.provinceId = orderData.provinceId || 0;
          userData.cityId = orderData.cityId || 0;
          if (Object.keys(userData).length > 0) {
            _this.$store.commit('booking/user/update', userData)
          }
          if (menu.menuId === menuId) { // 餐单一致 进入餐品本地回滚流程 初始化门店和餐单  以及订单改变验证
            await _this.recoverMenu(orderData.orderProducts, menu, {menuId, storeId});
            _this.$store.dispatch('booking/store/init', {data: {...store, deliveryFee: store.fee}});
            _this.$store.dispatch('booking/menu/init', {
              data: {...menu, menuId, brandId},
              removeEmptyCat: true
            });
            _this.orderAmendValidation([orderData, _this.oprInfo, _this.brandInfo, _this.store, _this.menu, isRouter]);
          } else { // 不一致抛出
            _this.modalError('原订单的餐单与门店对应的餐单不一致，不允许修改订单。');
            throw new Error()

            //  await _this.recoverMenu(orderData.orderProducts, menu, {menuId, storeId});
            // _this.$store.dispatch('booking/store/init', {data: {...store, deliveryFee: store.fee}});
            // _this.$store.dispatch('booking/menu/init', {
            //   data: {...menu, menuId, brandId},
            //   removeEmptyCat: true
            // });
            // _this.orderAmendValidation([orderData, _this.oprInfo, _this.brandInfo, _this.store, _this.menu, isRouter]);
         
          }
        }).catch(function () { // 结束改单
          _this.endAmend()
        })
      },
      endAmend() { // 结束改单
        this.$emit('updateRouterStatus', true);
        this.visible = true;
      },
      async orderAmendValidation([orderData, oprInfo, brandInfo, store, menu, isRouter]) {// 订单修改前的验证
        let {fromType, payType, orderPreferentials, orderProducts} = orderData, o = {},
          isAmend = true,
          isProducts = true,
          isBase = true,
          isStore = true,
          isChannel = fromType >= 20, // 是否自有渠道
          isDiscounts = false, // 其他优惠
          isOnlinePay = payType === 2,// 是否线上支付
          manualPreferentials = (orderData.productPrePrice || 0) + (store.fee > Math.abs(orderData.deliveryPrePrice) ? orderData.deliveryPrePrice: -store.fee || 0),
          promotionsList = [],
          ManualDiscountsData = [],
          {cartProducts} = await this.addProductsCart(orderProducts, orderData.menuId, orderData.storeId, false),
          isManualDiscounts = false; // 手动打折
        // 优惠列表 所有优惠收集
        each(orderPreferentials, (item) => {
          if (item.type === 6) {
            ManualDiscountsData.push(item);
            isManualDiscounts = true;
          } else {
            promotionsList.push(item)
          }
          isDiscounts = true;
        });
        // 赠送餐品
        each(orderProducts, product => {
          if (product.typeId === -1) {
            product.content = product.name;
            isDiscounts = true;
            promotionsList.push(product);
          }
        });
        each(cartProducts, product => { // 购物车餐品还原
          if (product.type === 1) this.$store.dispatch('booking/cart/doPlus', product);
          else if (product.type === 2) this.$store.dispatch('booking/cart/addGroups', product);
        });
        debugger
        isStore = !(isChannel || isDiscounts || isOnlinePay); // 渠道 优惠 在线
        isProducts = isStore;
        if (isBase) {
          Object.assign(o, {
            phone: orderData.consigneePhone,
            name: orderData.consigneeName,
            address: orderData.consigneeAddress,
            selfTakeaddress: orderData.consigneeAddress,
            storeId: orderData.storeId,
            sendType: orderData.orderType,
            longitude: orderData.longitude,
            latitude: orderData.latitude,
            districtDetailsAddress: orderData.cityName
          })
        }
        o['orderAmend'] = {
          isStore,
          orderData,
          isAmend, // 是否可以改单
          isProducts, // 是否可以更改餐品
          isOnlinePay, // 是否是线上支付
          isBase, // 是否可以更改基础信息（姓名、 电话、 备注、送餐地址）
        };
        this.$store.commit('booking/preferential/updateData', {
          manualPreferentials: ManualDiscountsData,
          list: promotionsList
        });
        // 统一把配送费优惠和其他优惠的金额，统一放在打折优惠那里
        this.$store.dispatch('booking/cart/updateFee', {manualDiscount: formatPrice(Math.abs(manualPreferentials))});
        this.$store.commit('booking/user/update', o);
        this.$store.dispatch('booking/order/update', {type: orderData.orderType});
        this.$emit('updateRouterStatus', true);
        this.getStorePromotions(store.storeId);
        if (isRouter) {
          this.$router.push({name: 'order'})
        }
        this.visible = true;
      },
      async addProductsCart(orderProducts, menuId, storeId, isRequestCombo) {// 添加进去购物车操作 isRequestCombo 是否需要请求套餐数据
        let menu = this.menu,
          productsRefIdMap = {},
          products = menu.products,
          {productsUseStockObj, productsUseMaterialStock, orderProductsObj, comboIds} = this.getOrderProductsSum(orderProducts),
          combosObj = {},
          productsObj = {},
          isCartProductsError = false,
          cartProducts = [];
        if (isRequestCombo) { // 是否需要请求套餐数据
          combosObj = await this.getProductsCombo(comboIds, menuId, storeId);
        }
        each(products, (product) => { // 餐单的餐品进行单个分类收集
          let uid = product.uid;
          if (product.hasOwnProperty('uid') && !productsObj.hasOwnProperty(uid)) {
            productsObj[uid] = product
          }
          if (product.type === 2 && product.productGroup) { // 获取套餐已经有的数据
            combosObj[uid] = deepClone(product.productGroup)
          }
        });
        each(orderProductsObj, products => {
          let product = products[0],
            pid = product.pid,
            num = 0;
          each(products, product => {
            num += product.num;
          });
          if (productsObj.hasOwnProperty(pid)) { // 餐品是否存在餐单
            let productObj = deepClone(productsObj[pid]);
            isDisabled(productObj);
            if (productObj.disabled || (productObj.maxNum !== null && num > productObj.maxNum)) { // 餐品是否禁用 餐品库存不满足
              isCartProductsError = true;
            }
            if (productObj.type === 1) { // 单品
              if (productObj.isRequirement) { // 特殊要求的餐品
                checkAdditional(productObj, products);
                cartProducts.push(productObj);
              } else {
                cartProducts.push({...productObj, num: product.num})
              }
            } else if (productObj.type === 2) { // 套餐
              productObj.productGroup = combosObj[pid];
              let combo = createCombo(productObj),
                {productRefIds, productMaterialStock, productStockObj} = combo,
                groups = [],
                list = [];
              each(products, product => { // 收集每份套餐的分类
                each(product.groups, group => {
                  groups.push(group)
                })
              });
              each(groups, product => {
                let selectProductsObj = {}, param = deepClone(combo.param), {mainList, auxiliaryItem} = param,
                  count = 0,
                  mainGroups = [];
                each([product], (group) => { // 收集选中的餐品以及数量
                  let {num, mains, exArea} = group, o = {}, list = [];
                  if (Array.isArray(mains)) {
                    each(mains, main => {
                      let {groups} = main;
                      if (groups && groups.length) list.push({groups, main: true});
                    })
                  }
                  if (exArea && exArea.groups) {
                    list.push({groups: exArea.groups, main: false})
                  }
                  each(list, item => {
                    let {groups, main} = item, mainKey = main ? 0 : 1;
                    each(groups, (group) => {
                      let {type} = group, key = [mainKey, type].join('-');
                      each(group.products, (product) => {
                        let {pid, itemIndex} = product;
                        o[key + '-'+ itemIndex+ '-' + pid] = product;
                      })
                    })
                  });
                  selectProductsObj = {...o};
                  count += num;
                });
                // 模版套餐的餐品收集与选中的餐品进行对比匹配计算
                auxiliaryItem && mainGroups.push({main: false, groupData: auxiliaryItem.items});
                each(mainList, main => {
                  let mainGroup = main.mainGroups;
                  mainGroups.push({main: true, groupData: {groupA: main}});
                  mainGroup && mainGroups.push({main: true, groupData: mainGroup});
                });
                each(mainGroups, obj => {
                  let {main, groupData} = obj, mainKey = main ? 0 : 1;
                  each(groupData, group => {
                    let items = Array.isArray(group.items) ? group.items : [group], type = group.type;
                    each(items, (item, index) => {
                      let checkValue = item.checkValue,
                        cells = item.cells,
                        key = [mainKey, type, index].join('-');
                      each(cells, (cell, index) => {
                        let pid = cell.pid, product = selectProductsObj[key + '-' + pid];
                        if (pid && product) {
                          cell.num = product.num;
                          checkValue = index;
                          if (Array.isArray(product.listPropertys)&&product.listPropertys.length) {
                            checkAdditional(cell, [product], true)
                          }
                        }
                      });
                      if (type === 2 || type === 4) {
                        checkValue = item.checkValue;
                      }
                      item.checkValue = checkValue
                    });
                  });
                });
                param.num = count;
                list.push(param);
              });
              if (list.length) combo.list = list;
              calculateAllCombo(productObj, combo);
             // console.log(combo)
              if (productRefIds.len) {
                Object.assign(productsRefIdMap, productRefIds);
              }
              if (productMaterialStock.len || productStockObj.len) {
                let {productUseNum, productUseMaterialStock} = getComboUseProductsAndMaterial(productObj.groups);
                if (productRefIds.len) {
                  let productUseRefIdMaterialStock = getRefIdMap(productsRefIdMap, productUseMaterialStock);
                  productUseMaterialStock = {...productUseMaterialStock, ...productUseRefIdMaterialStock}
                }
                productObj._combo.productUseNum = productUseNum;
                productObj._combo.productUseMaterialStock = productUseMaterialStock;
              }
              cartProducts.push(productObj)
            }
          }
        });

        function checkAdditional(product, groups, isCombo) { // 特殊要求还原
          let additional = product._additional || createAdditional(product),
            {stockObj, refIdObj} = additional,
            count = 0,
            listRequirements = [],
            list = [];
          each(groups, group => {  // 收集所有加料
            let items = group.listPropertys || group.listRequirements;
            if (Array.isArray(items)) {
              each(items, item => {
                listRequirements.push({listRequirements: item, num: item.num})
              })
            }
          });
          each(listRequirements, group => {
            let {num} = group, selectObj = {}, selectRef = {}, param = additional.param, options = [],
              listRequirements = group.listRequirements;
            each(listRequirements.propertys, (cell) => {
              let pid = cell.pid, selectItemObj = {},selectReqObj = {}, len = 0;
              each(cell.items, item => {
                selectItemObj[item.uid] = true;
                selectReqObj[item.uid] = item;
                len++;
              });
              if (len) {
                selectObj[pid] = selectItemObj;
                selectRef[pid] = selectReqObj;
              }
            });
            each(param.options, (option) => {
              let type = option.type, checkValue = [], cell = option.value, uid = cell.uid;
              if (selectObj[uid]) {
                let selectItemObj = selectObj[uid];
                let selectReqObj = selectRef[uid];
                each(cell.items, (item, index) => {
                   // item num selectNum 赋值 从listRequirements.propertys【订单】拿到num selectNum
                  let uid = item.uid;
                  if (selectItemObj.hasOwnProperty(uid)) {
                    checkValue.push(index)
                  }
                  if (selectReqObj.hasOwnProperty(uid)) {
                    item.originNum = selectReqObj[uid].num
                    item.originSelectNum = selectReqObj[uid].selectNum
                  }
                })
              }
              if (checkValue.length) {
                checkValue = type === 'radio' ? checkValue[0] : checkValue
              } else {
                checkValue = option.checkValue
              }
              let optionItem = {...option, checkValue: checkValue}
              optionItem = deepClone(optionItem)
              optionItem.value.items.map(item => {
                item.num = item.originNum || 0
                item.selectNum = item.originSelectNum || 0
              })
              options.push(optionItem)
            });
            count += num;
            list.push({...param, num, options})
          });
          if (isCombo) {
            each(list, item => {
              item.num = Math.floor(item.num/Math.floor(count/product.num));
            });
          }
          if (list.length) {
            additional.list = list;
          }
          calculateAllAdditional(product, additional);
          if (stockObj.len && !isCombo) {
            // 获取当前餐品的使用的加料库存
            let productUseMaterialStock = getAdditionalUseMaterial(product.listRequirements);
            if (refIdObj.len) {
              // 存在公共加料 导入到全局公共映射
              Object.assign(productsRefIdMap, refIdObj);
              // 计算公共加料用了多少库存与普通加料库存一起存 cartUseMaterialStock
              let productUseRefIdMaterialStock = getRefIdMap(productsRefIdMap, productUseMaterialStock);
              productUseMaterialStock = {...productUseMaterialStock, ...productUseRefIdMaterialStock};
            }
            product._additional.cartUseMaterialStock = productUseMaterialStock;
          }
          return product
        }

        return {cartProducts, isCartProductsError}
        // 餐品添加进购物车
      },
      async getProductsCombo(comboIds, menuId, storeId) { // 返回当前批量获取套餐数据
        let combosObj = {}, comboQueue = [], _this = this;
        if (comboIds.length) {
          each(comboIds, pid => {
            comboQueue.push(new Promise(function (resolve, reject) {
              _this.server.get({
                name: "getProductGroup",
                data: {
                  menuId,
                  pid,
                  storeId,
                  isCheckSoldOut: false,
                  isCheckStock: false
                }
              }).then((res) => {
                let data = res.data;
                resolve({pid, data})
              }).catch(() => {
                reject()
              })
            }))
          });
          await Promise.all(comboQueue).then(function ([...list]) {
            each(list, item => {
              let {pid, data} = item;
              if (pid && data) {
                combosObj[pid] = data;
              }
            })
          })
        }
        return combosObj
      },
      async recoverMenu(orderProducts, menu, {menuId, storeId}) {
        //  修改订单的餐单本地库存恢复 productsUseStockObj 使用加料   productsUseMaterialStock 使用加料 products 所有餐品集合  refIds 公共加料集合 productMaterialRefsItems // 公共加料的项集合
        let {productsUseStockObj, productsUseMaterialStock, comboIds} = this.getOrderProductsSum(orderProducts),
          products = [], refIds = {},
          productMaterialRefsItems = {},
          combosObj = await this.getProductsCombo(comboIds, menuId, storeId), // 套餐对象集合
          productsObj = {};
        // 汇总餐单所有餐品
        each(menu.bigs, (item) => {
          if (Array.isArray(item.products)) {
            products.push(...item.products);
          }
          if (item.hasOwnProperty('smalls')) {
            each(item.smalls, item => {
              if (Array.isArray(item.products)) {
                products.push(...item.products);
              }
            })
          }
        });
        each(combosObj, (combo) => {
          products.push(...getComboProducts(combo)) // 整合套餐所有的餐品
        });
        each(products, product => { // 恢复餐品的加料以及套餐附属
          let pid = product.uid || product.pid, list = productsObj[pid] || [];
          if (combosObj.hasOwnProperty(pid)) { // 套餐还原
            product.productGroup = combosObj[pid];
          }
          recoverProductMaterial(product, productsUseMaterialStock, productMaterialRefsItems, refIds);
          list.push(product);
          productsObj[pid] = list;
        });
        each(productsObj, (list, pid) => { //恢复餐品本身库存
          let product = list[0];
          if (productsUseStockObj.hasOwnProperty(pid)) {
            let isInServiceTime = true, isSoldOut = false, hasStock = product.hasStock, stockNum = product.stockNum;
            if (hasStock) {
              stockNum += productsUseStockObj[pid];
            }
            each(list, product => {
              Object.assign(product, {
                isInServiceTime,
                isSoldOut,
                hasStock,
                stockNum
              })
            })
          }
        });
        each(refIds, (refs, refId) => {
          let count = 0;
          each(refs, uid => {
            if (productsUseMaterialStock.hasOwnProperty(uid)) count += productsUseMaterialStock[uid];
          });
          if (productMaterialRefsItems[refId]) {  // 存在公共加料的恢复
            let items = productMaterialRefsItems[refId],
              item = items[0];
            count += (item.stockNum || 0);
            each(items, item => {
              Object.assign(item, {
                isSoldOut: false,
                hasStock: true,
                stockNum: count
              })
            })
          }
        });
        // 回滚餐品加料
        function recoverProductMaterial(product, productUseMaterialStock, productMaterialRefsItems, refIds) {
          if (product.isRequirement || product.property) {
            let property = product.property,
              s = property.standard,
              p = property.propertys,
              c = property.choices,
              list = [s, c];
            if (Array.isArray(p)) list.push(...p);
            each(list, cell => {
              if (cell) {
                each(cell.items, item => {
                  let {stockNum = 0, uid, refId, isSoldOut, hasStock} = item;
                  if (hasStock) {
                    if (productUseMaterialStock.hasOwnProperty(uid) && refId <= 0) {
                      isSoldOut = false;
                      stockNum = stockNum + productUseMaterialStock[uid];
                      Object.assign(item, {
                        isSoldOut,
                        stockNum
                      })
                    }
                    if (refId > 0) { // 公共加料收集
                      let items = productMaterialRefsItems[refId] || [],
                        refs = refIds[refId] || {};
                      items.push(item);
                      refs[uid] = uid;
                      productMaterialRefsItems[refId] = items;
                      refIds[refId] = refs;
                    }
                  }
                })
              }
            })
          }
        }
      },
      getOrderProductsSum(orderProducts) {  // 获取订单详情餐品集合使用的库存以及加料
        let orderProductsObj = {}, productsUseStockObj = {}, productsUseMaterialStock = {}, comboIds = [];
        each(orderProducts, product => {
          // 归类产品集合
          if (product.typeId !== -1) {
            let pid = product.pid,
              items = orderProductsObj[pid] || [];
            items.push(product);
            orderProductsObj[pid] = items;
          }
        });
        each(orderProductsObj, (items, pid) => {
          let count = productsUseStockObj[pid] || 0, item = items[0];
          each(items, product => {
            let listRequirements = product.listPropertys || product.listRequirements;
            count += product.num;
            if (Array.isArray(listRequirements)) {
              getAdditionalUseMaterial(listRequirements, productsUseMaterialStock, 1)
            }
            if (Array.isArray(product.groups)) {
              getComboUseProductsAndMaterial(product.groups, productsUseStockObj, productsUseMaterialStock)
            }
          });
          if (Array.isArray(item.groups) && item.groups) comboIds.push(pid);
          productsUseStockObj[pid] = count;
        });
        return {productsUseStockObj, productsUseMaterialStock, orderProductsObj, comboIds}
      },
      async productPrefetch({menuId, storeId}, orderProducts, menu) {
        // 餐品预获取判断
        // product 所有餐品集合 productsObj 所有餐品对象 productsStockObj 餐品库存对象 // 订单餐品对象  isMeet 是否满足 dissatisfyProducts 不满足的餐品集合 comboProducts // 订单套餐里面餐品集合
        let _this = this, products = [], productsObj = {}, productsStockObj = {}, isMeet = true,
          dissatisfyProducts = [],
          {productsUseStockObj, productsUseMaterialStock, orderProductsObj, comboIds} = this.getOrderProductsSum(orderProducts),
          combosObj = {};
        // 收集所有餐品
        each(menu.bigs, (item) => {
          if (Array.isArray(item.products)) {
            products.push(...item.products)
          }
          if (item.hasOwnProperty('smalls')) {
            each(item.smalls, item => {
              if (Array.isArray(item.products)) {
                products.push(...item.products);
              }
            })
          }
        });
        // 套餐餐品提取各个餐品
        if (comboIds.length) {
          combosObj = await this.getProductsCombo(comboIds, menuId, storeId);
          each(combosObj, (productGroup) => {
            if (!productGroup.isSoldOut) products.push(...getComboProducts(productGroup))
          })
        }
        // 所有餐品
        each(products, product => {
          let pid = product.uid, o = {...product};
          if (!productsObj[pid]) {
            if (combosObj[pid]) {
              o.productGroup = combosObj[pid]
            }
            product = o;
            isDisabled(product, product.type);
            productsObj[pid] = product;
            if (!product.disabled) {
              productsStockObj[pid] = product.maxNum;
            }
          }
        });
        // 收集订单详情餐品使用量
        each(orderProductsObj, (items, pid) => {
          let product = productsObj[pid];
          if (productsStockObj.hasOwnProperty(pid)) {
            let count = productsUseStockObj[pid] || 0;
            each(items, item => {
              count += item.num;
            });
            productsUseStockObj[pid] = count;
          } else {
            dissatisfyProducts.push(product)
          }
        });
        each(productsUseStockObj, (count, pid) => {
          if (productsStockObj.hasOwnProperty(pid) && productsStockObj[pid] !== null) {
            if (count > productsStockObj[pid]) dissatisfyProducts.push(productsObj[pid])
          }
        });
        isMeet = !dissatisfyProducts.length;
        return {isMeet, orderProductsObj, productsObj, dissatisfyProducts, combosObj}
      },
      getOrderDetails(orderId) { // 获取订单详情
        return this.server
          .get({
            name: 'getOrderDetail',
            data: {
              orderIdList: [orderId]
            }
          })
          .then(res => {
            let list = res.data;
            if (list.length > 0) {
              let data = list[0],
                order = data.order,
                orderProductOwns = data.orderProductOwns,
                products = [],
                orderProducts = order.orderProducts;
              if (Array.isArray(orderProductOwns)) {
                products.push(...orderProductOwns);
                order.orderProducts = products;
              }
              return order
            }
          })
      },
      async openOrderPage(store) { // 进入餐单页面
        let {sendType, address, name, phone, orderAmend} = this,
          storeId = store.storeId;
        if (orderAmend.isAmend) { // 进入改单流程
          this.$emit('updateRouterStatus', false);
          let orderData = orderAmend.orderData,
            orderType = orderData.orderType,
            oldStoreId = orderData.storeId,
            oldMenuId = orderData.menuId,
            storeData,
            status = true,
            msg = '',
            menuId,
            menuData,
            menuSource
          if (this.store.storeId === storeId) { //当前门店是否要进入的门店一样
            this.$emit('updateRouterStatus', true);
            return this.$router.push({name: 'order'});
          } else if (storeId !== oldStoreId) {
            if (orderAmend.isStore) {
              if (this.store.storeId === storeId) return;
              storeData = await this.getStoreInfo({
                storeId,
                longitude: orderData.longitude,
                latitude: orderData.latitude,
                businessType: orderType
              });
              storeData.isBusy = false; // 忽略繁忙，DC判断
              if (storeData.isBusy) {
                status = false;
                msg = '当前门店不在营业时间，不可接单，请重新选择。'
              } else {
                menuSource = await this.getStoreMenu({orderType, storeId, businessType: orderType});
                if (menuSource.status === 1) {
                  menuData = menuSource.data;
                  menuId = menuData.menuId;
                  if (menuId !== oldMenuId) {
                    status = false;
                    msg = '新门店餐单与原门店不一致，请重新选择。'
                  } else {
                    let {isMeet} = await this.productPrefetch({menuId, storeId}, orderData.orderProducts, menuData);
                    if (isMeet) {
                      this.$store.dispatch('booking/cart/clear');
                      this.$store.dispatch('booking/menu/init', {
                        data: menuData,
                        removeEmptyCat: true
                      });
                      this.$store.commit('booking/user/update', {storeId: storeData.storeId});
                      this.$store.dispatch('booking/store/init', {data: storeData});
                      let {cartProducts} = await this.addProductsCart(orderData.orderProducts, menuId, storeId, true);
                      each(cartProducts, product => {
                        if (product.type === 1) this.$store.dispatch('booking/cart/doPlus', product);
                        else if (product.type === 2) this.$store.dispatch('booking/cart/addGroups', product);
                      });
                      this.getStorePromotions(storeData.storeId);
                      this.$emit('updateRouterStatus', true);
                      this.$router.push({name: 'order'});
                      return
                    } else {
                      msg = '餐品存在异常情况（售罄、库存不足、餐品供应时间、停用、删除），请重新选择。'
                    }
                    status = isMeet
                  }
                } else {
                  status = false;
                  msg = '当前门店餐单不支持'
                }
              }
            } else {
              status = false;
              msg = '该订单不可以更改门店';
            }
          } else {
            return this.orderAmendInit(orderData.orderId, true)
          }
          this.$emit('updateRouterStatus', true);
          if (!status) {
            return this.modalError(msg)
          }
        }
        if ((sendType !== 2 && !address) || !name || !phone) {
          this.modalError('顾客信息未填写完全，将会影响门店配送或顾客就餐')
        }
        this.$store.dispatch('booking/user/update', {
          storeId: store.storeId,
          isNeedTableware: store.isNeedTableware
        });
        this.$store.dispatch('booking/cart/updateCommon');
        this.$router.push({name: 'order'});
      },
      getStoreMenu({orderType, storeId}) { //获取餐单
        return this.server.get({
          name: "getProductMenu",
          data: {
            storeId,
            sendType: orderType
          }
        }).then(res => {
          return res
        })
      },
      getStoreInfo({storeId, longitude, latitude, businessType}) {
        return this.server.get({
          name: "getStoreInfoForCC",
          data: {
            storeId,
            coordinate: [longitude, latitude],
            businessType
          }
        }).then(res => {
          return res.data
        })
      },
      getStorePromotions(storeId) { //获取门店优惠活动
        return this.server
          .get({
            name: "getStorePres",
            data: {
              storeId
            }
          })
          .then(res => {
            this.$store.dispatch('booking/preferential/init', res.data)
          })
      },
    },
    components: {
      ccUser: User,
      ccOrderInfo: OrderInfo,
      ccStoreList: StoreList
    },
    watch: {}
   
  }
</script>
<style scoped>
  .customer-order-amend-title {
    margin-left: -30px;
    margin-top: -16px;
    height: 40px;
    font-size: 18px;
    color: #fff;
    background-color: #3bb5e4;
    text-indent: 20px;
    line-height: 40px;
  }
</style>
<style lang="scss">
  .customer {
    padding: 64px 0 0 30px;
    .title {
      background-color: transparent;
      text-align: left;
      margin-bottom: 0;
      font-family: Microsoft Yahei;
      font-weight: 700;
      line-height: 42px;
      height: 42px;
      font-size: 16px;
      color: #3e3f43;
    }
    .z-title {
      float: left;
      height: 100%;
      margin-right: 12px;
    }
    .z-content {
      float: left;
      height: 100%;
    }
    input.text {
      width: 160px;
      height: 30px;
      border: 1px solid #59738c;
      text-indent: 8px;
    }
    .g-content > ul > li {
      height: 42px;
      line-height: 42px;
    }
    .g-content > ul > li:after {
      content: '';
      display: block;
      clear: both;
    }
    .shopInfo {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 48px;
      line-height: 48px;
      background-color: #ececec;
      z-index: 900;
    }
    .shopInfo p {
      margin-left: 10px;
    }
    .shopInfo p span {
      padding: 0 10px;
    }
    a.dark, a.light {
      display: inline-block;
      height: 30px;
      line-height: 30px;
      padding: 0 9px;
      color: #fff;
      border-radius: 3px;
      background-color: #3b5d8b;
    }
    a.light {
      background-color: #3bb5e4;
    }
    .z-tip-his {
      width: 54px;
      padding: 0 6px;
      height: 18px;
      line-height: 18px;
      font-size: 12px;
      background-color: #3fa2ff;
      color: #fff;
      border-radius: 2px;
    }

    .font_blue {
      color: #3fa2ff;
    }
    .font_red {
      color: #f73f3f;
    }
    .font_orange {
      color: #FF9900;
    }

    .storeList-modal-body {
      font-size: 14px;
      text-align: center;
      padding: 50px 0;
    }
    .storeList-modal-footer {
      text-align: center;
      padding: 0;
      height: 100px;
    }
  }
</style>




// WEBPACK FOOTER //
// pagesCache/customer/customer.vue